import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import {CommonModule, registerLocaleData} from '@angular/common';

registerLocaleData(localeDe, localeDeExtra);

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HttpClientModule} from '@angular/common/http';
import {PageLayoutComponent} from './page-layout/page-layout.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {initializeKeycloak} from './init/keycloak-init.factory';
import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatLegacyMenuModule as MatMenuModule} from '@angular/material/legacy-menu';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatLegacyListModule as MatListModule} from '@angular/material/legacy-list';
import {StationsComponent} from './stations/stations.component';
import {MatLegacyTableModule as MatTableModule} from '@angular/material/legacy-table';
import {MatLegacyPaginatorModule as MatPaginatorModule} from '@angular/material/legacy-paginator';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {StatisticComponent} from './stations/statistic/statistic.component';
import {RegionalOfficeImportComponent} from './regional-office-import/regional-office-import.component';
import {MatLegacyDialogModule as MatDialogModule} from '@angular/material/legacy-dialog';
import {ButtonComponent} from './button/button.component';
import {StationViewComponent} from './station-view/station-view.component';
import {TextInputComponent} from './text-input/text-input.component';
import {StationDashboardComponent} from './station-dashboard/station-dashboard.component';
import {FilterComponent} from './filter/filter.component';
import {MatLegacyCheckboxModule as MatCheckboxModule} from '@angular/material/legacy-checkbox';
import {SectionComponent} from './section/section.component';
import {DiagramsComponent} from './diagrams/diagrams.component';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import {MatLegacySelectModule as MatSelectModule} from '@angular/material/legacy-select';
import {PointDiagramComponent} from './diagrams/point-diagram/point-diagram.component';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {DialogComponent} from './dialog/dialog.component';
import {GetStatusCommentValue, ParseDate} from './util';
import {OperatorCardComponent} from './operator-card/operator-card.component';
import {ChartModule, HIGHCHARTS_MODULES} from 'angular-highcharts';
import {HumidityChartComponent} from './diagrams/humidity-chart/humidity-chart.component';
import {TemperatureChartComponent} from './diagrams/temperature-chart/temperature-chart.component';
import {WindChartComponent} from './diagrams/wind-chart/wind-chart.component';
import {
  PrecipitationHourlyChartComponent
} from './diagrams/precipitation-hourly-chart/precipitation-hourly-chart.component';
import {PrecipitationChartComponent} from './diagrams/precipitation-chart/precipitation-chart.component';
import {EditStationComponent} from './edit-station/edit-station.component';
import {MatLegacyAutocompleteModule as MatAutocompleteModule} from '@angular/material/legacy-autocomplete';
import exporting from 'highcharts/modules/exporting.src';
import windbarb from 'highcharts/modules/windbarb.src';


export function highchartsModules() {
  // apply Highcharts Modules to this array
  return [ exporting,windbarb ];
}

import {ImagesComponent} from './images/images.component';
import {DateAdapter, MAT_DATE_LOCALE} from "@angular/material/core";
import {MatLegacyOptionModule as MatOptionModule} from "@angular/material/legacy-core";
import {OperatorsComponent} from './operators/operators.component';
import {OperatorViewComponent} from './operator-view/operator-view.component';
import {EditOperatorFieldComponent} from './edit-operator-field/edit-operator-field.component';
import {OperatorStationViewComponent} from './operator-station-view/operator-station-view.component';
import {OperatorAddStationComponent} from './operator-add-station/operator-add-station.component';
import {ImageFullscreenViewerComponent} from './image-fullscreen-viewer/image-fullscreen-viewer.component';
import {ConfirmationDialogComponent} from './confirmation-dialog/confirmation-dialog.component';
import {MatLegacyProgressSpinnerModule as MatProgressSpinnerModule} from '@angular/material/legacy-progress-spinner';
import {SensorPipePipe} from './diagrams/sensor-pipe.pipe';
import {MatLegacyCardModule as MatCardModule} from "@angular/material/legacy-card";
import {DialogCommentComponent} from './dialog-comment/dialog-comment.component';
import {MatExpansionModule} from "@angular/material/expansion";
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {CustomDateAdapter} from './filter/CustomDateAdapter';
import {InformationStatusCreationComponent} from './information/information-status-creation/information-status-creation.component';
import {CreateNoteComponent} from './create-note/create-note.component';
import {InformationBannerComponent} from './information/information-banner/information-banner.component';
import {DialogSensorComponent} from './dialog-sensor/dialog-sensor.component';
import {ExplanationComponent} from './explanation/explanation.component';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {filterReducer} from './filterState/filter-state.reducer';
import {reducers, metaReducers} from './reducers';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {environment} from '../environments/environment';
import { AdditionalStationInfoComponent } from './additional-station-info/additional-station-info.component';
import { AddStationInfoDialogComponent } from './add-station-info-dialog/add-station-info-dialog.component';
import {MatLegacySlideToggleModule as MatSlideToggleModule} from "@angular/material/legacy-slide-toggle";

@NgModule({
  declarations: [
    AppComponent,
    PageLayoutComponent,
    StationsComponent,
    StatisticComponent,
    RegionalOfficeImportComponent,
    ButtonComponent,
    StationViewComponent,
    TextInputComponent,
    StationDashboardComponent,
    FilterComponent,
    SectionComponent,
    DiagramsComponent,
    PointDiagramComponent,
    DialogComponent,
    ParseDate,
    GetStatusCommentValue,
    PointDiagramComponent,
    HumidityChartComponent,
    OperatorCardComponent,
    TemperatureChartComponent,
    WindChartComponent,
    PrecipitationHourlyChartComponent,
    PrecipitationChartComponent,
    EditStationComponent,
    SensorPipePipe,
    ImagesComponent,
    OperatorsComponent,
    OperatorViewComponent,
    EditOperatorFieldComponent,
    OperatorStationViewComponent,
    OperatorAddStationComponent,
    ImageFullscreenViewerComponent,
    ConfirmationDialogComponent,
    DialogCommentComponent,
    InformationStatusCreationComponent,
    CreateNoteComponent,
    InformationBannerComponent,
    DialogSensorComponent,
    ExplanationComponent,
    AdditionalStationInfoComponent,
    AddStationInfoDialogComponent
  ],
  imports: [
    AppRoutingModule,
    CommonModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    KeycloakAngularModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatSidenavModule,
    MatListModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatCheckboxModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    ScrollingModule,
    ChartModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatExpansionModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    EffectsModule.forRoot(),
    StoreModule.forRoot(reducers, {metaReducers}),
    StoreModule.forFeature('filterState', filterReducer),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    MatSlideToggleModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
    { provide: HIGHCHARTS_MODULES, useFactory: highchartsModules },// add as factory to your providers
    { provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
    { provide: DateAdapter, useClass: CustomDateAdapter}
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
